import { all, call, put, takeEvery } from 'redux-saga/effects'
import { globalLoaderText } from "redux/CommonDashboard/actions";
import FleetManagementApiService from './FleetManagementApiService'
import { GET_FLEET_DISPOSITION_LOCATION_SAVE } from '../../Store/FleetManagement/FleetDispositionLocationsave/FleetDispositionLocationsaveType'
import { setSaveFleetDispositionLocation } from 'Store/FleetManagement/FleetDispositionLocationsave/FleetDispositionLocationsaveAction';
import { setGlobalLoader } from 'Store/Component/GlobalLoader/GlobalLoaderAction';
import { API_URL, apiMethod, apiType } from 'utils';
import { IPayload } from 'Model/IPayload';

function* SaveFleetDispositionLocationSaveSaga(req: any): any {
    try {
        yield put(globalLoaderText("Saving values...."));
        yield put(setGlobalLoader({ fleetDispositionLocationSave: true }));

        let payloadData : IPayload= {
            apiType : apiType.FleetManagement,
            endpoint : `fleet/physicallocation/asset`, 
            apiMethod :  apiMethod.POST,
            payload : req?.fleetdispositionLocationSave
            
        }
        const response = yield call(
            FleetManagementApiService.post,
            API_URL.PostWebApp, payloadData
        );
        if (response) {
            yield put(setSaveFleetDispositionLocation({...response,physicalAssetLocation : req?.fleetdispositionLocationSave?.physicalAssetLocation}));
        }
    } catch (error) {
        yield put(globalLoaderText(""));
    } finally {
        yield put(globalLoaderText(""));
        yield put(setGlobalLoader({ fleetDispositionLocationSave: false }));
    }
}

function* watchGetFleetDispositionLocationSave() {
    yield takeEvery(GET_FLEET_DISPOSITION_LOCATION_SAVE, SaveFleetDispositionLocationSaveSaga)
}

export default function* combinedSaga() {
    yield all([
        watchGetFleetDispositionLocationSave()
    ])
}
